import promiseDone from 'hs-promise-utils/promiseDone';
import { UNINITIALIZED, FAILED } from 'redux-request-state/requestStates';
import { makeLatestArtifactSelector } from 'automation-ui-canvas/selectors/requestStateSelectors';
import { fetchWithEarlyRequestHook } from 'automation-ui-canvas/utils/apiDataUtils';
const emptyFunction = () => {};
export function createRequestAction(requestTypes, requestEntity) {
  return {
    type: requestTypes.REQUESTED,
    payload: requestEntity
  };
}
export function createSuccessAction(requestTypes, requestEntity, response) {
  return {
    type: requestTypes.SUCCEEDED,
    payload: {
      requestEntity,
      response
    }
  };
}
export function createFailureAction(requestTypes, requestEntity, error) {
  return {
    type: requestTypes.FAILED,
    payload: {
      requestEntity,
      error
    }
    // meta: getErrorNotification(requestTypes),
  };
}
export default function simpleApiRequest(apiFunction, requestTypes, earlyRequestName, forceRefresh = false) {
  return function (requestEntity, callback = emptyFunction) {
    return (dispatch, getState) => {
      const request = makeLatestArtifactSelector(requestTypes.getKey())(getState());
      if (!(requestTypes.once && !forceRefresh) || [UNINITIALIZED, FAILED].includes(request.requestState)) {
        dispatch(createRequestAction(requestTypes, requestEntity));
        let earlyRequest;
        if (earlyRequestName) {
          earlyRequest = fetchWithEarlyRequestHook(() => simpleApiRequest(apiFunction, requestTypes)(requestEntity, callback)(dispatch, getState), earlyRequestName, requestEntity);
        }
        const apiRequest = !earlyRequest || !earlyRequest.then ? apiFunction(requestEntity) : earlyRequest;
        const returnApiRequest = apiRequest.then(response => dispatch(createSuccessAction(requestTypes, requestEntity, response)), error => {
          if (earlyRequestName) {
            return simpleApiRequest(apiFunction, requestTypes, null, true)(requestEntity, callback)(dispatch, getState);
          }
          return dispatch(createFailureAction(requestTypes, requestEntity, error));
        }).then(callback);
        return promiseDone(returnApiRequest);
      }
      if (!Promise) {
        throw new Error('Promise polyfill missing. Fix by adding the polyfill HeadJS bundle to your application.');
      }

      // Note: ideally should be resolving `undefined` instead of an empty object, but to prevent regressions leaving it here
      return Promise.resolve({}).then(callback);
    };
  };
}